export const NAME = 'nominations';

export const CAMPAIGN_NOMINATIONS_SUBHEADER = `${NAME}/CAMPAIGN_NOMINATIONS_SUBHEADER`;
